export enum Icons {
  Cross = 'cross',
  ArrowRight = 'arrow_right',
  Menu = 'menu',
  Checkmark = 'checkmark',
  Minus = 'minus',
  Plus = 'plus',
  Info = 'info-icon',
  Phone = 'phone',
  Sizes = 'sizes',
  Pickup = 'pickup',
}
